import * as React from 'react';

export const GreenTick = () =>
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8">
    <path
      fill="#2E9E00"
      fillRule="nonzero"
      d="M1.138 3.283a.667.667 0 1 0-.943.943l3.138 3.138L9.56 1.138a.667.667 0 1 0-.943-.943L3.333 5.478 1.138 3.283z"
    />
  </svg>;
